import { lazy, Suspense } from 'react';
import { Outlet, createRoute, SearchSchemaInput } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { OrdersListSearchParamsSchema } from 'src/sections/orders/view';
import { OrderDetailsSearchParamsSchema } from 'src/sections/orders/order-details/view';

import { rootRoute } from './root';
import { issueDetailsRoute } from './issues';

const OrdersList = lazy(() => import('src/sections/orders/view'));
const OrderDetails = lazy(() => import('src/sections/orders/order-details/view'));
const ExportOrders = lazy(() => import('src/sections/orders/export-orders'));

// Orders routes
export const ordersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'orders',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const ordersIndexRoute = createRoute({
  getParentRoute: () => ordersRoute,
  path: '/',
  validateSearch: (search: unknown & SearchSchemaInput) =>
    OrdersListSearchParamsSchema.validateSync(search),
  component: OrdersList,
});

const ordersExportRoute = createRoute({
  getParentRoute: () => ordersRoute,
  path: 'export',
  component: ExportOrders,
});

const orderDetailsRoute = createRoute({
  getParentRoute: () => ordersRoute,
  path: '$orderId',
  component: OrderDetails,
  validateSearch: (search: unknown & SearchSchemaInput) =>
    OrderDetailsSearchParamsSchema.validateSync(search),
});

export const ordersRouteTree = ordersRoute.addChildren([
  ordersIndexRoute,
  orderDetailsRoute,
  ordersExportRoute,
  issueDetailsRoute,
]);
